<template>
  <base-modal ref="modal" @hiding="reset()" :overflowAuto="false">
    <base-card shadow>
      <h3 class="tw-text-xl tw-font-thin tw-mb-5">Assign Activity</h3>
      <base-advanced-select label="Assign to" :options="businessUsers" v-model="selectedUser" placeholder="Select a user" label-key="fullName" value-key="userId" />
      <inline-error id="assign-todo-error" class="tw-my-3" :title="errorTitle" :message="errorMessage" :error="error" />
      <div class="sm:tw-flex sm:tw-flex-row-reverse tw-mt-4">
        <base-button @click="saveAssignment" :loading="isLoading" class="tw-w-full sm:tw-w-auto sm:tw-ml-3">Assign</base-button>
        <base-button @click="hide" type="flat" class="tw-w-full sm:tw-w-auto tw-mt-2 sm:tw-mt-0">
          Cancel
        </base-button>
      </div>
    </base-card>
  </base-modal>
</template>

<script>
import { mapGetters } from "vuex";
import InlineError from "@/components/InlineError";

export default {
  name: "AssignTodoItem",
  components: { InlineError },
  props: {
    businessId: String,
  },
  data() {
    return {
      businessUsers: [],
      allUsers: [],
      isLoading: false,
      selectedUser: null,
      todoItemId: null,
      currentAssignedUserId: null,
      businessLocationId: null,
      errorTitle: "",
      errorMessage: "",
      error: null,
      allowedActivityTypes: ["Refill Authorization", "Prescriber Clarification"],
    };
  },
  computed: {
    ...mapGetters("cognito", { userId: "id" }),
  },
  created() {
    this.loadBusinessUsers();
  },
  methods: {
    show(todoItem) {
      this.todoItemId = todoItem.todoItemId;
      this.currentAssignedUserId = todoItem.assignedToUserId;
      this.businessLocationId = todoItem.businessLocationId;
      if (todoItem.businessLocationId !== null) {
        this.filterBusinessUsers(this.businessLocationId, todoItem);
      } else {
        this.businessUsers = this.allUsers;
      }
      if (this.currentAssignedUserId) this.selectedUser = this.businessUsers.find((x) => x.userId == this.currentAssignedUserId);
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },
    reset() {
      this.selectedUser = null;
      this.loadBusinessUsers();
      this.errorTitle = "";
      this.errorMessage = "";
      this.error = null;
    },
    loadBusinessUsers() {
      this.$axios.get(`/businesses/${this.businessId}/users/all`).then((res) => {
        this.allUsers = res.data;
        var index = this.allUsers.findIndex((x) => x.userId === this.userId);

        if (index > 0) this.allUsers[index].fullName = "(Me) " + this.allUsers[index].fullName;
      });
    },
    filterBusinessUsers(businessLocationId, todoItem) {
      var userOptions = [];
      if (this.allowedActivityTypes.includes(todoItem.todoItemTypeLabel)) {
        //Add location users
        userOptions.push({
          businessId: null,
          email: null,
          hasPin: false,
          locations: [],
          roles: [],
          userId: null,
          fullName: "-- Prescriber Location Users --",
          isHeader: true,
        });

        var locationUsers = this.allUsers
          .filter((x) => x.locations.length > 0 && x.locations.find((l) => l.businessLocationId === businessLocationId))
          .sort((a, b) => (a.fullName > b.fullName ? 1 : b.fullName > a.fullName ? -1 : 0));
        for (var j = 0; j < locationUsers.length; j++) {
          userOptions.push({
            businessId: locationUsers[j].businessId,
            email: locationUsers[j].email,
            fullName: locationUsers[j].fullName,
            hasPin: locationUsers[j].hasPin,
            locations: locationUsers[j].locations,
            roles: locationUsers[j].roles,
            userId: locationUsers[j].userId,
            isHeader: false,
          });
        }
      }

      //Add RxH users
      userOptions.push({
        businessId: null,
        email: null,
        hasPin: false,
        locations: [],
        roles: [],
        userId: null,
        fullName: "-- RxHarmony Users --",
        isHeader: true,
      });

      var rxhUsers = this.allUsers.filter((x) => x.locations.length === 0).sort((a, b) => (a.fullName > b.fullName ? 1 : b.fullName > a.fullName ? -1 : 0));
      for (var i = 0; i < rxhUsers.length; i++) {
        userOptions.push({
          businessId: rxhUsers[i].businessId,
          email: rxhUsers[i].email,
          fullName: rxhUsers[i].fullName,
          hasPin: rxhUsers[i].hasPin,
          locations: rxhUsers[i].locations,
          roles: rxhUsers[i].roles,
          userId: rxhUsers[i].userId,
          isHeader: false,
        });
      }

      this.businessUsers = userOptions;
    },
    saveAssignment() {
      this.isLoading = true;

      this.$axios
        .put(`/businesses/${this.businessId}/todo/${this.todoItemId}`, {
          assignedToUserId: this.selectedUser.userId,
          status: "assigned",
        })
        .then(() => {
          this.EventBus.$emit("GLOBAL_NOTIFY", {
            title: "Activity Assigned",
            message: `Your activity was assigned to ${this.businessUsers.find((x) => x.userId == this.selectedUser.userId).fullName}.`,
          });
          this.EventBus.$emit("activitiesUpdated");
          this.hide();
        })
        .catch((err) => {
          this.errorTitle = `Error assigning activity`;
          this.errorMessage = "Sorry, we had trouble assigning this activity. The technicians have been notified. Please try again.";
          this.error = err;
        })
        .finally(() => {
          this.reset();
          this.isLoading = false;
        });
    },
  },
};
</script>
